import script from "./report-pane-resizer.vue?vue&type=script&setup=true&lang=ts"
export * from "./report-pane-resizer.vue?vue&type=script&setup=true&lang=ts"

import "./report-pane-resizer.vue?vue&type=style&index=0&id=67ff526f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ff526f"]])

export default __exports__